import React, {useState, useRef} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, FreeMode, Thumbs } from 'swiper/modules';
import {MEDIA} from "../../../utils/js/Const";
import "./PlannogrammTackStyle.scss";
import "./PlanogrammTasckSliderStyle.scss"
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import "../../../utils/js/UtilsJs"
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import {AddBodyModifikator, RemoveBodyModifikator} from "../../../utils/js/UtilsJs";

function PLannogrammTaskSlider ({ img }) {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const transformRef = useRef(null);
    const thumbsSwiperRef = useRef(null);

    function OpenFullSize(index = 0) {
        setCurrentImageIndex(index);
        setIsFullscreen(true);
        AddBodyModifikator();
    }

    function CloseFullSize() {
        setIsFullscreen(false);
        RemoveBodyModifikator();
    }

    const goToNextImage = () => {
        if (img && img.length > 0) {
            const newIndex = currentImageIndex === img.length - 1 ? 0 : currentImageIndex + 1;
            setCurrentImageIndex(newIndex);
            setTimeout(() => {
                if (transformRef.current) {
                    transformRef.current.resetTransform();
                }
            }, 50);
        }
    };

    const goToPrevImage = () => {
        if (img && img.length > 0) {
            const newIndex = currentImageIndex === 0 ? img.length - 1 : currentImageIndex - 1;
            setCurrentImageIndex(newIndex);
            setTimeout(() => {
                if (transformRef.current) {
                    transformRef.current.resetTransform();
                }
            }, 50);
        }
    };

    // Функции для навигации миниатюр
    const goToNextThumb = () => {
        if (thumbsSwiperRef.current) {
            thumbsSwiperRef.current.swiper.slideNext();
        }
    };

    const goToPrevThumb = () => {
        if (thumbsSwiperRef.current) {
            thumbsSwiperRef.current.swiper.slidePrev();
        }
    };

    const handleKeyDown = (e) => {
        if (!isFullscreen) return;

        switch(e.key) {
            case 'ArrowLeft':
                e.preventDefault();
                goToPrevImage();
                break;
            case 'ArrowRight':
                e.preventDefault();
                goToNextImage();
                break;
            case 'Escape':
                e.preventDefault();
                CloseFullSize();
                break;
        }
    };

    React.useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isFullscreen, currentImageIndex]);

    const zoomIn = () => {
        if (transformRef.current) {
            transformRef.current.zoomIn();
        }
    };

    const zoomOut = () => {
        if (transformRef.current) {
            transformRef.current.zoomOut();
        }
    };

    const resetTransform = () => {
        if (transformRef.current) {
            transformRef.current.resetTransform();
        }
    };

    return (
        <>
            {isFullscreen && (
                <div className="fullscreen-container">
                    <div className="fullscreen-image-wrapper">
                        <button className="control-button nav-button-side nav-button-prev" onClick={goToPrevImage}>
                            ᐸ
                        </button>

                        <TransformWrapper
                            ref={transformRef}
                            initialScale={1}
                            minScale={0.1}
                            maxScale={20}
                            centerOnInit={true}
                            limitToBounds={false}
                            panning={{ velocityDisabled: false, lockAxisX: false, lockAxisY: false }}
                            doubleClick={{ disabled: false }}
                            key={currentImageIndex}
                        >
                            <TransformComponent>
                                <img
                                    className="fullscreen-image"
                                    src={`${MEDIA}/api/attachments/${img[currentImageIndex]?.img}`}
                                    alt={`Изображение ${currentImageIndex + 1}`}
                                />
                            </TransformComponent>
                        </TransformWrapper>

                        <button className="control-button nav-button-side nav-button-next" onClick={goToNextImage}>
                            ᐳ
                        </button>
                    </div>

                    <div className="bottom-controls-panel">
                        <div className="controls-row navigation-row">
                            <div className="thumbs-container">
                                <button
                                    className="thumbs-nav-button thumbs-prev"
                                    onClick={goToPrevThumb}
                                >
                                    ᐸ
                                </button>

                                <Swiper
                                    ref={thumbsSwiperRef}
                                    modules={[FreeMode, Navigation]}
                                    watchSlidesProgress={true}
                                    freeMode={true}
                                    spaceBetween={8}
                                    slidesPerView="auto"
                                    centeredSlides={false}
                                    centerInsufficientSlides={true}
                                    slidesOffsetBefore={0}
                                    slidesOffsetAfter={0}
                                    onSwiper={setThumbsSwiper}
                                    className="thumbs-swiper"
                                    navigation={{
                                        nextEl: '.thumbs-next',
                                        prevEl: '.thumbs-prev',
                                    }}
                                >
                                    {img.map((item, index) => (
                                        <SwiperSlide key={index} style={{ width: 'auto' }}>
                                            <img
                                                src={`${MEDIA}/api/attachments/${item.img}`}
                                                alt={`Миниатюра ${index + 1}`}
                                                className={`thumb-image ${index === currentImageIndex ? 'active' : ''}`}
                                                onClick={() => {
                                                    setCurrentImageIndex(index);
                                                    setTimeout(() => {
                                                        if (transformRef.current) {
                                                            transformRef.current.resetTransform();
                                                        }
                                                    }, 50);
                                                }}
                                            />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>

                                <button
                                    className="thumbs-nav-button thumbs-next"
                                    onClick={goToNextThumb}
                                >
                                    ᐳ
                                </button>
                            </div>
                        </div>

                        <div className="controls-row zoom-row">
                            <div className="zoom-controls">
                                <button className="control-button zoom-button" onClick={zoomOut} title="Уменьшить">
                                    -
                                </button>
                                <button className="control-button zoom-button" onClick={resetTransform} title="Сбросить масштаб">
                                    ⊡
                                </button>
                                <button className="control-button zoom-button" onClick={zoomIn} title="Увеличить">
                                    +
                                </button>
                            </div>
                            <button className="control-button close-button" onClick={CloseFullSize} title="Закрыть">
                                ×
                            </button>
                        </div>
                    </div>

                    <div className="image-counter">
                        {currentImageIndex + 1} / {img.length}
                    </div>
                </div>
            )}

            <Swiper
                pagination={{ type: 'fraction' }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="mySwiper"
            >
                {Array.isArray(img) && img.length > 0 ? (
                    img.map((item, index) => (
                        <SwiperSlide key={index}>
                            <img
                                src={`${MEDIA}/api/attachments/${item.img}`}
                                alt={`Изображение ${index}`}
                                loading="lazy"
                                onClick={() => OpenFullSize(index)}
                                style={{ cursor: 'pointer' }}
                            />
                        </SwiperSlide>
                    ))
                ) : (
                    <SwiperSlide>
                        <div className="Slider_none_img">Нет фото</div>
                    </SwiperSlide>
                )}
            </Swiper>
        </>
    );
};

export default PLannogrammTaskSlider;